import { BannedIPKeys } from "@sso/constant";
import { SearchFieldKeys, TableColumn } from "@sso/types";

export const bannedIPTableColumns: TableColumn<BannedIPKeys>[] = [
  {
    name: "User Id",
    field: BannedIPKeys.USER_ID,
    sortable: true,
    search: { type: SearchFieldKeys.TEXT },
  },
  {
    name: "IP",
    field: BannedIPKeys.IP,
    sortable: true,
  },
  {
    name: "Ban Date",
    field: BannedIPKeys.BAN_DATE,
    sortable: true,
  },
  {
    name: "Reason",
    field: BannedIPKeys.REASON,
    search: { type: SearchFieldKeys.TEXT },
  },
];
